import { YandexMetrikaAbTestModule } from '@analytics/feature';
import { AsyncPipe, NgClass, NgFor, NgIf, NgTemplateOutlet } from '@angular/common';
import { NgModule } from '@angular/core';
import {
  MobileMenuItemComponent,
  MobileMenuStepComponent,
  SdvorGenericLinkComponent,
  SdvorLinkComponent,
} from '@sdvor/shared/ui';
import { MediaModule } from '@spartacus/storefront';
import { PagesNavigationComponent } from './pages-navigation.component';
import { DesktopPagesNavigationComponent } from './views/desktop/desktop-pages-navigation.component';
import { MobilePagesNavigationComponent } from './views/mobile/mobile-pages-navigation.component';

@NgModule({
  declarations: [PagesNavigationComponent, DesktopPagesNavigationComponent, MobilePagesNavigationComponent],
  imports: [
    NgFor,
    NgIf,
    NgClass,
    AsyncPipe,
    NgTemplateOutlet,
    SdvorGenericLinkComponent,
    SdvorLinkComponent,
    MobileMenuItemComponent,
    MobileMenuStepComponent,
    MediaModule,
    YandexMetrikaAbTestModule,
  ],
  exports: [PagesNavigationComponent],
})
export class PagesNavigationModule {}
